module.exports = __webpack_public_path__ + "static/media/auv.fcb3dea4.JPG";